import {
  appLogout,
  createAsyncThunk,
  createSlice,
  injectSlice,
  PayloadAction,
} from '@betty/toolkit/state';
import WalletService from '../../services/WalletService/WalletService';
import { CoinBalanceState } from './coinBalance.types';

export const getCoinBalance = createAsyncThunk(
  'coinBalance/get',
  async () => await WalletService.getCoinBalance(),
);

const initialState: CoinBalanceState = {
  data: 0,
  dataState: 'idle',
};

const coinBalance = createSlice({
  name: 'coinBalance',
  initialState,
  reducers: {
    setCoinBalance(state, { payload }: PayloadAction<number>) {
      state.data = payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getCoinBalance.pending, (state) => {
      if (state.dataState === 'fulfilled') {
        state.dataState = 'refreshing';
      } else {
        state.dataState = 'pending';
      }
    });

    builder.addCase(getCoinBalance.rejected, (state) => {
      state.dataState = 'rejected';
    });

    builder.addCase(getCoinBalance.fulfilled, (state, { payload }) => {
      state.dataState = 'fulfilled';
      state.data = payload.amount;
    });

    builder.addCase(appLogout, (state) => {
      Object.assign(state, initialState);
    });
  },
});

export const { setCoinBalance } = coinBalance.actions;

const withCoinBalance = injectSlice({
  reducerPath: 'coinBalance',
  reducer: coinBalance.reducer,
});

export const selectCoinBalance = withCoinBalance.selector(
  (state) => state.coinBalance.data,
);
export const selectCoinBalanceDataState = withCoinBalance.selector(
  (state) => state.coinBalance.dataState,
);

declare global {
  interface LazyLoadedSlices {
    coinBalance: ReturnType<typeof coinBalance.reducer>;
  }
}
